import { Button } from "@/components/ui/button";
import { ArrowRight, LifeBuoy } from "lucide-react";
import { Link } from "react-router-dom";
import { usePartner } from "@/context/PartnerContext";

const scrollToForm = () => {
  document.getElementById("cotizar")?.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  const { config, linkBase } = usePartner();

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 border-b border-gray-200/80 bg-white/80 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 h-20 sm:h-24 flex items-center justify-between">
        <div className="flex items-center min-w-0">
          <a href="#top" data-testid="brand-logo" className="flex items-center shrink-0">
            <img
              src="/brand/logo.png"
              alt="OperaSafe.cl — Protegemos todo lo que mueve tu operación industrial"
              className={`${config ? "h-9 sm:h-12 lg:h-16" : "h-12 sm:h-16 md:h-[72px]"} w-auto`}
            />
          </a>

          {config && (
            <div
              data-testid="header-partner-cobrand"
              className="flex shrink-0 items-center gap-2 border-l border-gray-300 pl-2 ml-2 sm:ml-3 sm:gap-3 sm:pl-3"
            >
              <span className="hidden text-[10px] font-medium uppercase leading-none tracking-wider text-gray-400 lg:block">
                en alianza<br />exclusiva con
              </span>
              {config.logoChip ? (
                <span className={`inline-flex items-center rounded-md px-2 py-1 ${config.logoChip}`}>
                  <img
                    src={config.logo}
                    alt={config.name}
                    className={`${config.logoClass || "h-4 sm:h-7"} w-auto`}
                  />
                </span>
              ) : (
                <img
                  src={config.logo}
                  alt={config.name}
                  className={`${config.logoClass || "h-6 sm:h-8 w-auto"} shrink-0`}
                />
              )}
            </div>
          )}
        </div>

        <div className="flex items-center gap-2 sm:gap-4 shrink-0">
          <Link
            to={`${linkBase}/siniestro`}
            data-testid="header-siniestro-link-mobile"
            aria-label="Gestionemos tu siniestro"
            title="Gestionemos tu siniestro"
            className={`inline-flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 bg-white text-brand-ink transition-colors hover:border-brand-yellow hover:text-brand-gold ${config ? "lg:hidden" : "sm:hidden"}`}
          >
            <LifeBuoy className="h-5 w-5" />
          </Link>
          <Link
            to={`${linkBase}/siniestro`}
            data-testid="header-siniestro-link"
            className={`hidden items-center h-11 rounded-full border border-gray-300 bg-white px-5 text-sm font-semibold text-brand-ink hover:border-brand-yellow hover:text-brand-gold transition-colors ${config ? "lg:inline-flex" : "sm:inline-flex"}`}
          >
            Gestionemos tu siniestro
          </Link>
          <Button
            data-testid="header-cotizar-btn"
            onClick={scrollToForm}
            className={`group h-11 rounded-full bg-brand-ink hover:bg-brand-inkHover text-white text-sm font-semibold ${config ? "pl-2 lg:pl-5" : "pl-5"} pr-2 gap-2 transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-brand-ink/25 hover:shadow-xl hover:shadow-brand-ink/40`}
          >
            <span className={config ? "hidden" : "sm:hidden"}>Cotizar</span>
            <span className={config ? "hidden lg:inline" : "hidden sm:inline"}>Cotizar mi seguro</span>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-yellow text-brand-ink transition-transform duration-300 group-hover:translate-x-0.5">
              <ArrowRight className="h-4 w-4" />
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};
